export default "__VITE_ASSET__79966402__"